import { convertToExportedView } from '@estee/elc-service';
import { CART_SIDEBAR_CART_OFFERS } from '@estee/elc-service-view-names';
import { serviceNames } from '~setup/OffersService';
import ICartSidebarCartOffers from './ICartSidebarCartOffers';

export const VIEW_NAME = CART_SIDEBAR_CART_OFFERS;
export type INTERFACE = ICartSidebarCartOffers;

// @ts-ignore
export default convertToExportedView<ICartSidebarCartOffers>(
    () => import('./CartSidebarCartOffers'),
    CART_SIDEBAR_CART_OFFERS,
    serviceNames.offersViewController
);
